import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ubs-pms',
  template: `
  <ng-container *ngIf="isHome;else isView">
    <ubs-pms-home></ubs-pms-home>
  </ng-container>
  <ng-template #isView>
    <ubs-view-containers></ubs-view-containers>
  </ng-template>
  `,
  styles: [
    ':host { height: 100%; }'
  ]
})
export class PmsComponent implements OnInit {
  isHome:boolean = false;

  constructor(private router: Router) { 
    let parts = this.router.url.split("/");
    if(parts[(parts.length-1)] == "pms"){
      this.isHome = true;
    } 
  }

  ngOnInit(): void {

  }

}
